// extracted by mini-css-extract-plugin
export default {"root":"file-input_root__VZl4G","files":"file-input_files__k0Zl1","item":"file-input_item__vGohS"};